enum CourseType {
  Regular = 'regular',
  Additional = 'additional',
}

export default CourseType
